<template>
  <modal-wrapper class="update-password-modal" gray-bg>
    <template #header>
      <h2 class="font-normal align-middle">
        <i class="bdg-icon lock text-xl" />
        Change Password
      </h2>
    </template>
    <template #body>
      <div class="form-container">
        <bdg-password-field
          ref="currentPassword"
          name="Current password"
          v-model="currentPassword"
          required
        />
        <bdg-password-field
          ref="newPassword"
          name="New password"
          v-model="newPassword"
          required
        />

        <div class="flex justify-between items-center w-full mt-5 lg:mt-10">
          <bdg-button
            class="ghost no-min-width flex-grow mr-3 uppercase"
            @click.native="cancel"
          >
            cancel
          </bdg-button>
          <bdg-button
            class="no-min-width flex-grow uppercase"
            :is-loading="isUpdatingPassword"
            @click.native="submit"
          >
            submit
          </bdg-button>
        </div>
      </div>
    </template>
  </modal-wrapper>
</template>

<script>
import ModalWrapper from "./ModalWrapper";
import BdgPasswordField from "../../forms/fields/BdgPasswordField";
import BdgButton from "../../elements/BdgButton";

export default {
  name: "UpdatePasswordModal",
  components: { BdgButton, BdgPasswordField, ModalWrapper },
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      requiredRefs: ["currentPassword", "newPassword"]
    };
  },
  computed: {
    isUpdatingPassword() {
      return this.$store.state.Users.isUpdatingPassword;
    }
  },
  methods: {
    cancel() {
      this.$store.commit("resetModalParams");
    },
    submit() {
      this.$store.dispatch("updatePassword", {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.update-password-modal {
  .form-container {
    @screen lg {
      min-width: 24rem;
    }
  }
}
</style>
